<template>
  <div>
    <div v-if="isLoading">
      <div
        v-for="index in skeletonCount"
        :key="index"
        class="time-card-item rounded border-start border-4 placeholder-glow"
      >
        <slot name="skeleton" :index="index">
          <div class="d-flex justify-content-between align-items-center">
            <strong class="placeholder col-4"></strong>
            <span class="placeholder col-2"></span>
          </div>
          <div class="d-flex justify-content-between mt-2">
            <span class="placeholder col-4"></span>
            <span class="placeholder col-3"></span>
          </div>
        </slot>
      </div>
    </div>

    <div
      v-else-if="!data || data.length === 0"
      class="text-center text-muted p-3"
    >
      <i class="bi bi-database-x"></i> No data available
    </div>

    <div v-else>
      <div
        v-for="(item, index) in data"
        :key="item.id || index"
        class="time-card-item rounded border-start border-4"
        :class="getItemClass(item)"
      >
        <slot name="item" :item="item" :index="index" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
    isLoading: Boolean,
    skeletonCount: {
      type: Number,
      default: 5,
    },
    getItemClass: {
      type: Function,
      default: () => "",
    },
  },
};
</script>

<style scoped>
.time-card-item {
  background: #f8f9fa;
  padding: 0.75rem;
  margin-bottom: 0.65rem;
}

.time-card-item:last-child {
  margin-bottom: 0;
}

.placeholder {
  display: inline-block;
  height: 1rem;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.placeholder-glow {
  animation: placeholder-glow 1.5s infinite ease-in-out;
}

@keyframes placeholder-glow {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}
</style>
